var CustomerRegister = class extends HTMLElement {
  triggerButtons = this.querySelectorAll('button[data-action="switch-form"]')
  loginFormElement = this.querySelector('#login-form-container')
  recoverFormElement = this.querySelector('#recover-form-container')
  registerFormElement = this.querySelector('#register-form-container')

  klaviyoCheck = this.querySelector("#toggleSubscribeEmail");
  registerForm = this.querySelector("#register-customer");
  registerButton = this.querySelector("#register-customer .form__submit");
  klaviyoForm = this.querySelector('div.klaviyo-hidden-form>form');

  urlParams = new URLSearchParams(window.location.search);
  registerParam = this.urlParams.has('register');


  connectedCallback() {
    this.registerButton.addEventListener("click", e => this.formSubmitHandler(e));
    this.triggerButtons.forEach((button) => {
      button.addEventListener('click', (e) => this.switchForm(e));
    });

    if (this.loginFormElement && this.registerFormElement) {
      if (this.registerParam) {
        // If the parameter '?something' exists, show register form and hide login form
        this.registerFormElement.classList.add('visible');
        this.loginFormElement.classList.remove('visible');

      }
    }
  }
  


  switchForm(e) {
    e.preventDefault() 
    const target = e.currentTarget;
    const targetDataId = target.getAttribute('data-toggler-id');
    if (targetDataId == 'register-container-toggler') {
        this.loginFormElement.classList.remove('visible')
        this.registerFormElement.classList.add('visible') 

    } else if (targetDataId == 'password-container-toggler') {
        this.loginFormElement.classList.remove('visible')
        this.recoverFormElement.classList.add('visible')  

    } else {
        this.registerFormElement.classList.remove('visible')
        this.recoverFormElement.classList.remove('visible')
        this.loginFormElement.classList.add('visible') 

    } 
  }
  
  formSubmitHandler(e) {
    if (this.registerForm.checkValidity() === false) { 
      e.preventDefault();
      e.stopPropagation();
      for (const el of this.registerForm.querySelectorAll("[required]")) {
        if (!el.reportValidity()) { 
          console.log(!el.reportValidity());
          return;
        }
      }
    } else {
      if(this.klaviyoCheck.checked) { 
      e.preventDefault();
  
      $('#klaviyo_register_id_email').val($('#register-customer .email-input-field').val())
        
        const formData = new FormData(this.klaviyoForm);
        const url = this.klaviyoForm.action;
        console.log(url);
        console.log(formData);
        
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded", // Change content type to URL encoded form data
      },
      body: new URLSearchParams(formData), // Convert the serialized data to URLSearchParams format
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data); 
      })
      .catch((error) => {
        console.error("Error:", error);
      });
        
        this.registerForm.submit();
      } 
    }
  }
    
  };
  window.customElements.define("customer-register", CustomerRegister);
   